import {useGlobals} from '../../../../globalPropsContext';
import {StatesButtonStates} from '@wix/wix-ui-tpa/cssVars';
import {AddToCartActionStatus} from '../../../../constants';

export const useBaseAddToCartState = (productId: string) => {
  const {addedToCartStatus, shouldShowAddToCartSuccessAnimation} = useGlobals();
  const isAddedSuccessfully = addedToCartStatus[productId] === AddToCartActionStatus.SUCCESSFUL;
  const isInProgress = addedToCartStatus[productId] === AddToCartActionStatus.IN_PROGRESS;

  if (shouldShowAddToCartSuccessAnimation && isAddedSuccessfully) {
    return StatesButtonStates.SUCCESS;
  } else if (isInProgress) {
    return StatesButtonStates.IN_PROGRESS;
  }
  return StatesButtonStates.IDLE;
};
